<template>
  <vs-prompt
    title="Add special day"
    @accept="acceptClicked"
    :active.sync="popupOpen"
    accept-text="Add"
    :is-valid="validForm"
  >
    <div v-if="schema">
      <div class="vx-row mb-6 w-full">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Day</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <flat-pickr
            :config="configdateDatePicker"
            v-model="schema.day"
            class="flatpickr-field"
            placeholder="Opens at..."
          />
        </div>
      </div>

      <div class="vx-row mb-6 w-full">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Status</span>
        </div>
        <div class="vx-col sm:w-3/5">
          <vs-switch v-model="schema.isOpen">
            <span slot="on">Open</span>
            <span slot="off">Closed</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6 w-full" v-if="schema.isOpen">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Opens at</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <v-date-picker
            class="custom-time-picker"
            is24hr
            mode="time"
            v-model="schema.open"
            :timezone="timezone"
          />
        </div>
      </div>

      <div class="vx-row mb-6 w-full" v-if="schema.isOpen">
        <div class="vx-col sm:w-1/5 w-full">
          <span class="day">Closes at</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <v-date-picker
            class="custom-time-picker"
            is24hr
            mode="time"
            v-model="schema.close"
            :timezone="timezone"
          />
        </div>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: { flatPickr },
  data() {
    return {
      timezone: "",
      popupOpen: false,
      schema: null,
      schemaOrg: {
        isOpen: true,
        day: "2023-08-28T09:35:00Z",
        open: "2023-08-28T09:35:00Z",
        close: "2023-08-28T14:17:00Z",
      },
      configdateDatePicker: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        altInput: true,
        altFormat: "d-m-Y",
        dateFormat: "Z", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        altInput: true,
        altFormat: "H:i",
        dateFormat: "Z",
        defaultHour: 0,
        defaultMinute: 0,
        defaultSecond: 0,
      },
    };
  },
  computed: {
    validForm() {
      return true;
    },
  },
  mounted() {},
  methods: {
    show() {
      this.schema = Object.assign({}, this.schemaOrg);
      this.popupOpen = true;
    },
    /*     onOpenChange(selectedDates) {
      if (selectedDates.length == 1) {
        console.log("Open change", selectedDates[0].toISOString());
        this.schema.open = selectedDates[0].toISOString();
      }
    },
    onCloseChange(selectedDates) {
      if (selectedDates.length == 1) {
        this.schema.close = selectedDates[0].toISOString();
      }
    },
    onDayChange(selectedDates) {
      if (selectedDates.length == 1) {
        this.schema.day = selectedDates[0].toISOString();
      }
    }, */
    async acceptClicked() {
      const day = Object.assign({}, this.schema);
      this.$emit("onAdd", day);
    },
  },
};
</script>

<style>
.custom-time-picker .vc-date {
  display: none !important;
}
</style>

<style lang="scss" >
.flatpickr-field {
  color: inherit;
  position: relative;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 0 0 rgb(0 0 0 / 15%);
  transition: all 0.3s ease;
  font-size: 1rem !important;
  padding: 0.7rem !important;
}
.day {
  font-weight: 500;
  width: 100px;
}

.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>
